import sizeOf from 'image-size';
import {Buffer} from 'buffer'; // Import Buffer explicitly for browser compatibility

const getImageDimensions = (base64Image) => {
    const base64Data = base64Image.replace(/^data:.+;base64,/, '');
    const imageBuffer = Buffer.from(base64Data, 'base64');
    const dimensions = sizeOf(imageBuffer);
    return dimensions;
};

export default getImageDimensions;
